// removed by extract-text-webpack-plugin
module.exports = {"Objective":"Objective__Objective___1EDdm","Summary":"Objective__Summary___3kXmz"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResumeBox/Resume/Objective/Objective.css
// module id = 44
// module chunks = 0